import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const jobvite = defineConnector({
  identifier: "jobvite",
  name: "Jobvite",
  tagLine: "Talent acquisition suite",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: () => "https://api\\.jobvite\\.com/.*",
  auth: (app) =>
    queryAuth([
      { name: "api", value: app.config.apiKey },
      { name: "sc", value: app.secret.apiSecret },
    ]),
  steps: [
    {
      title: "Get your Jobvite API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to Jobvite and navigate to **Settings > API** to obtain your API key and secret.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "configuration", field: "apiKey" },
        },
        {
          kind: "input",
          label: "API secret",
          required: true,
          target: { kind: "secrets", field: "apiSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => `https://api.jobvite.com/api/v2/job?count=1`,
  },
});
